import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Products from './components/Products';
import CustomServices from './components/CustomServices';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F5E6D3]">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Features />
      <Products />
      <CustomServices />
      <About />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
